const azureBlobBaseUrl = 'https://www.sorra.net/blog/wp-content/uploads/';
const imageProxyUrl = 'https://imgproxy.sorra.net/any/';
const defaultWidth = '300';
const fileExtension = '@webp';
// example: https://www.sorra.net/blog/wp-content/uploads/2025/07/1.jpg -> https://imgproxy.sorra.net/any/w1024/xxx@webp
const imageLoader = ({ src, width }) => {
  if (!src) {
    return '';
  }
  if (src.startsWith(azureBlobBaseUrl)) {
    return (src = imageProxyUrl + 'w' + width + '/' + src + fileExtension);
  } else {
    return src;
  }
};

const WebpBlogImg = (props) => {
  const { src, width, ...restProps } = props;
  if (!src) {
    return '';
  }

  const adjustedWidth = width || defaultWidth;
  const strapiSrc = imageLoader({ src, width: adjustedWidth });

  return <img src={strapiSrc} {...restProps} />;
};

export default WebpBlogImg;
